// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"movie_wrapper__WTefR","slide":"movie_slide__37m6m","movie":"movie_movie__2CHOX"};